import { EveryoneIcon, StudentIcon, DonorsIcon } from "../../lib/icons";
import { FAQS } from "../../data/content";

/** FAQ groups + palette. Colours follow the swash rotation after the tangerine masthead. */
export const FAQ_GROUPS = [
  {
    key: "general",
    title: "For everyone",
    note: "start here",
    blurb: "Who we are, how gifts move, and what happens when things don't go to plan.",
    icon: EveryoneIcon,
    text: "text-cobalt", bg: "bg-cobalt", border: "border-cobalt",
    tint: "rgba(3, 34, 244, 0.07)",
  },
  {
    key: "students",
    title: "For students",
    note: "before you build",
    blurb: "Eligibility, what you can raise for, and how a grant actually reaches you.",
    icon: StudentIcon,
    text: "text-grass", bg: "bg-grass", border: "border-grass",
    tint: "rgba(10, 155, 6, 0.09)",
  },
  {
    key: "donors",
    title: "For donors",
    note: "before you give",
    blurb: null,
    icon: DonorsIcon,
    text: "text-blossom", bg: "bg-blossom", border: "border-blossom",
    tint: "rgba(253, 152, 217, 0.18)",
  },
];

export const groupOf = (key) => FAQ_GROUPS.find((g) => g.key === key);
export const faqsFor = (key) => FAQS.filter((f) => f.group === key);

/** Flatten a string / JSX answer to plain text so search covers everything. */
const textOf = (node) => {
  if (node == null || typeof node === "boolean") return "";
  if (typeof node === "string" || typeof node === "number") return String(node);
  if (Array.isArray(node)) return node.map(textOf).join(" ");
  if (node.props) return textOf(node.props.children);
  return "";
};

/** Case-insensitive, all-words-must-match search across question + answer text. */
export const searchFaqs = (query) => {
  const q = query.trim().toLowerCase();
  if (q.length < 2) return [];
  const words = q.split(/\s+/).filter(Boolean);
  return FAQS.filter((f) => {
    const hay = `${f.q} ${textOf(f.a)}`.toLowerCase();
    return words.every((w) => hay.includes(w));
  });
};
